import infoList from '../../data/haInfoList.json'
import { Container } from 'react-bootstrap'

const HaInfo = () => {
  return (
    <>
      <Container
        style={{
          padding: '1rem',
          textAlign: 'justify',
          fontFamily: 'Noto Sans TC,sans-serif',
        }}
      >
        <div style={{ padding: '1rem', lineHeight: '1.5' }}>
          <h4 style={{ color: '#28d9c4' }}>使用條款</h4>
          <p>最後更新⽇期：2022年11⽉ 25⽇</p>
          <p>
            以下服務條款（以下簡稱本協議）是由浚鴻數據開發股份有限公司（下稱「本公司」），適⽤於HA！健康（下稱「本應⽤程式」）。無論您是透過註冊或其他⽅式取得本應⽤程式，均表⽰您同意本協議並受以下內容拘束，請您詳閱本協議內容，若您無法或不願受本協議拘束，請勿註冊帳⼾或使⽤本應用程式。
          </p>
          <p>
            ⼀旦您同意本協議，即代表您已充分審閱、了解本協議內容，且您已達法定年齡，具有完全的⾏為能⼒及權限簽定本協議。如您尚未達法定年齡或沒有完全⾏為能⼒，在使⽤本應用程式之前，您必須已先取得⽗⺟親（或其他有權的法定代理⼈）同意及允許您使⽤本應用程式以及訂定本協議。您的使⽤，即表⽰您已經取得了該等同意及允許。如您完全無⾏為能⼒，您無法使⽤本應用程式亦無法訂定本協議時，請勿使⽤本應用程式或者您可以請您的⽗⺟（或其他有權的法定代理⼈）代為處理。
          </p>
        </div>
        {infoList.map((item, index) => {
          return (
            <div key={index} style={{ padding: '1rem' }}>
              <h4>{item.title}</h4>
              <p style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>
                {item.content}
              </p>
              {/* {item.url && (
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  {item.url}
                </a>
              )} */}
            </div>
          )
        })}
      </Container>
    </>
  )
}

export default HaInfo
